<app-external-navbar></app-external-navbar>
<div class="mask d-flex justify-content-center align-items-center">
  <div class="container mt-5 pt-5">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card z-depth-2">
            <div class="card-body p-0">
              <div class="row mx-0">
                <div class="col-lg-6 py-5 px-md-5 d-none d-lg-block">
                  <div class="view">
                    <img src="../../../assets/img/SecureLogin.png" class="img-fluid mt-lg-5" alt="Trakly Login" />
                  </div>
                </div>

                <div class="col-lg-6 col-sm-12 cloudy-knoxville-gradient accent-3 py-5 px-md-5">
                  <div class="text-center border border-light p-5 w-100">
                    <img src="../../../assets/img/Trakly_Logo_3.png" class="img-fluid" alt="Responsive image" />
                    <p class="h3 mb-4">Admin Portal</p>

                    <form #signInForm="ngForm" (ngSubmit)="SignIn(signInForm)" *ngIf="!showOtpVerification">
                      <p class="h4 mb-4">Sign in</p>

                      <div class="md-form">
                        <input
                          type="email"
                          id="materialLoginFormEmail"
                          class="form-control"
                          mdbInput
                          mdbValidate
                          [(ngModel)]="signIn.email"
                          name="email"
                          #email="ngModel"
                          required
                          [pattern]="regexForEmail"
                        />
                        <label for="materialLoginFormEmail">E-mail</label>
                        <mdb-error *ngIf="email.invalid && (email.dirty || email.touched)">Please ensure email address is valid</mdb-error>
                      </div>

                      <div class="md-form">
                        <div class="input-group mb-3">
                          <input
                            [type]="showPasswordField ? 'password' : 'text'"
                            id="materialLoginFormPassword"
                            class="form-control"
                            mdbInput
                            mdbValidate
                            [(ngModel)]="signIn.password"
                            name="password"
                            required
                          />
                          <label for="materialLoginFormPassword">Password</label>
                          <div class="input-group-append">
                            <mdb-icon
                              *ngIf="!showPasswordField"
                              far
                              icon="eye"
                              class="prefix"
                              (click)="showPassword()"
                              size="lg"
                            ></mdb-icon>
                            <mdb-icon
                              *ngIf="showPasswordField"
                              far
                              icon="eye-slash"
                              class="prefix"
                              (click)="showPassword()"
                              size="lg"
                            ></mdb-icon>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-around">
                        <div>
                          <a routerLink="/resetpassword" routerLinkActive="active">Forgot password?</a>
                        </div>
                      </div>

                      <button *ngIf="!busy" mdbBtn color="trakly-action"block="true" class="my-4" type="submit">Sign in</button>

                      <div *ngIf="busy" class="spinner-grow text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>

                      <!-- <p>Not a member?
                                            <a routerLink="signup" routerLinkActive="active">Sign up</a>
                                        </p> -->
                    </form>

                    <form #otpForm="ngForm" (ngSubmit)="VerifyOtp(otpForm)" *ngIf="showOtpVerification">
                      <p class="h5 mb-4">Please verify your identity</p>
                      <p class="mb-4">An OTP has been sent to your email address</p>
                      <div class="md-form">
                        <div class="input-group mb-3">
                          <input
                            type="text"
                            id="otp"
                            class="form-control"
                            mdbInput
                            mdbValidate
                            name="otp"
                            #otp="ngModel"
                            [(ngModel)]="otpUser.otp"
                            required
                          />
                          <label for="txtOtp">OTP</label>
                          <mdb-error *ngIf="otp.invalid">OTP is required</mdb-error>
                        </div>
                      </div>
                      <button *ngIf="!otpBusy" mdbBtn color="trakly-action" block="true" class="my-4" type="submit">Verify OTP</button>
                      <div *ngIf="otpBusy" class="spinner-grow text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </form>

                    <div *ngIf="showError" class="alert alert-danger" role="alert">
                      {{ errorMsg }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
<!-- 
<div class="container-fluid">
    
    <div class="row mt-5">
        <div class="col-xl-4 col-lg-6 col-md-10 col-sm-12 mx-auto mt-lg-5">
            <mdb-card class="mb-4 wow fadeIn">
                <mdb-card-body class="d-sm-flex justify-content-between">
                    <form class="text-center border border-light p-5 w-100" (ngSubmit)="SignIn()">
                        <img src="../../../assets/img/Trakly_Logo.PNG" class="img-fluid" alt="Responsive image">
                        <p class="h4 mb-4">Sign in</p>

                        <div class="md-form">
                            <input type="email" id="materialLoginFormEmail" class="form-control" mdbInput
                                [(ngModel)]="signIn.email" name="email">
                            <label for="materialLoginFormEmail">E-mail</label>
                        </div>

                        <div class="md-form">
                            <input type="password" id="materialLoginFormPassword" class="form-control" mdbInput
                                [(ngModel)]="signIn.password" name="password">
                            <label for="materialLoginFormPassword">Password</label>
                        </div>

                        <div *ngIf="showError" class="alert alert-danger" role="alert">
                            {{errorMsg}}
                        </div>

                        <div class="d-flex justify-content-around">
                            <div>
                                <a routerLink="/resetpassword" routerLinkActive="active">Forgot password?</a>
                            </div>
                        </div>

                        <button *ngIf="!busy" mdbBtn color="trakly"block="true" class="my-4" type="submit">Sign in</button>
                        
                        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>

                        <p>Not a member?
                            <a routerLink="signup" routerLinkActive="active" >Sign up</a>
                        </p>
                    </form>
                    <div>

                    </div>

                </mdb-card-body>

            </mdb-card>

        </div>
    </div>
</div> -->
